import React, { useState } from "react";
import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT + "/api/data";

export const fetchMetaData = async (jwt) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.get(`${apiEndpoint}/studies-metadata`, {
    headers,
  });
  return response.data;
};

export const fetchStudyDetails = async (jwt, study) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.post(`${apiEndpoint}/study-details`, study, {
    headers,
  });
  return response.data;
};

export const uploadFile = async (jwt, data) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.post(`${apiEndpoint}/upload-file`, data, {
    headers,
  });
  return response.data;
};


export const topOptions = async (jwt, data) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.get(`${apiEndpoint}/top-candidates-options`, {
    headers,
  });

  return response.data;
};

export const topCandidates = async (jwt, data) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.post(`${apiEndpoint}/top-candidates`, data, {
    headers,
  });
  return response.data;
};


export const adminPanel = async (jwt, data) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.get(`${apiEndpoint}/admin-panel`, {
    headers,
  });

  return response.data.clients;
};

export const deleteStudy = async (jwt, data) => {
  const headers = {
    accept: "application/json",
    Authorization: `Bearer ` + jwt,
  };

  var response = await http.post(`${apiEndpoint}/delete-study`, data, {
    headers,
  });
  return response.data;
};